import React from 'react'
import { Input, Select, SelectContent, SelectTrigger, SelectItem, Icon } from '@shopflo/ui'
import { Gift } from '@phosphor-icons/react'
import {
  CouponType,
  DiscountApplyToType,
  UiConfigDiscountType,
  PurchaseConditionType,
  PurchaseConditionAmountType,
  EntitledCatalogueSelectionMode
} from 'src/lib/types/discountsV2'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import FreebieProductsList from './FreebieProductsList'
import DiscountInfoText from '../../../common/DiscountInfoText'
import { useLocale } from 'src/lib/hooks/useLocal'

const FreebieEntitlement = () => {
  const {
    state: { entitlement, uiConfig },
    actions: { setFormState }
  } = useDiscountForm()
  const { t } = useLocale()

  if (entitlement.type !== CouponType.BXGY) return null

  // Ensure uiConfig is FREEBIE
  if (uiConfig.type !== UiConfigDiscountType.FREEBIE) return null

  const { applyTo } = entitlement as any // Cast because applyTo is optional on BxgyEntitlement

  const handleTargetChange = (value: string) => {
    let applyTo = DiscountApplyToType.SPECIFIC_PRODUCTS

    if (value === 'specific_products') {
      applyTo = DiscountApplyToType.SPECIFIC_PRODUCTS
    } else if (value === 'specific_collections') {
      applyTo = DiscountApplyToType.SPECIFIC_COLLECTIONS
    }

    setFormState({
      entitlement: {
        ...entitlement,
        applyTo,
        // Reset catalogue when switching types for cleanliness
        entitledCatalogue: [
          {
            quantity: 1,
            entities: [],
            selectionMode: EntitledCatalogueSelectionMode.ANY
          }
        ],
        excludedCatalogue: [],
        metaData: {
          ...entitlement.metaData,
          entitledCatalogue: [],
          excludedCatalogue: []
        }
      }
    })
  }

  return (
    <div className='flex flex-col w-full gap-3'>
      <div className='flex gap-3 w-full '>
        <div className='flex-1'>
          <Input
            value={t('discounts_v2.free_label')}
            readOnly
            dimension='md'
            startAdornment={
              <div className='pl-3 pr-2 flex items-center'>
                <Icon IconComponent={Gift} size='sm' className='text-zinc-500' />
              </div>
            }
            className='w-full text-zinc-500 bg-zinc-50 cursor-not-allowed pointer-events-none'
          />
        </div>

        <div className='flex-1'>
          <Select
            value={applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS ? 'specific_collections' : 'specific_products'}
            onValueChange={handleTargetChange}
          >
            <SelectTrigger
              className='w-full h-9 bg-white rounded-lg opacity-100 cursor-default text-zinc-800'
              showCaret
            >
              <div className='p-1 truncate'>
                {applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS
                  ? t('discounts_v2.on_specific_collections')
                  : t('discounts_v2.on_specific_products')}
              </div>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value='specific_products'>{t('discounts_v2.on_specific_products')}</SelectItem>
              <SelectItem value='specific_collections'>{t('discounts_v2.on_specific_collections')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <DiscountInfoText
        text={t('discounts_v2.freebie_info')}
        show={entitlement.entitledCatalogue?.some(group => group?.entities?.length > 0) || false}
      />
      {(applyTo === DiscountApplyToType.SPECIFIC_PRODUCTS || applyTo === DiscountApplyToType.SPECIFIC_COLLECTIONS) && (
        <FreebieProductsList />
      )}
    </div>
  )
}

export default FreebieEntitlement
